import { useEffect, useRef, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { db } from '../../config/firebaseConfig';
import { useTranslation } from '../../i18n/LanguageContext';

/** Whether the selected employee already has a portal account (Users, by e-mail). */
const useEmployeeAccountStatus = (selectedEmployee) => {
  const { t } = useTranslation();
  const tRef = useRef(t);
  tRef.current = t;
  const [selectedEmployeeHasUser, setSelectedEmployeeHasUser] = useState(false);
  const [isCheckingUser, setIsCheckingUser] = useState(false);

  // Effect to check if selected employee has a user account
  useEffect(() => {
    const checkUserExists = async () => {
      if (selectedEmployee && selectedEmployee.eMail) {
        setIsCheckingUser(true);
        setSelectedEmployeeHasUser(false); // Reset
        try {
          // Check Users collection first based on email
          // IMPORTANT: Assumes the email field in Users collection is named 'email'
          const usersRef = collection(db, 'Users');
          const q = query(usersRef, where('email', '==', selectedEmployee.eMail));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            setSelectedEmployeeHasUser(true);
          } else {
             // Optional: Check Employees collection for a userId field if that exists
             // Example: if (selectedEmployee.userId) setSelectedEmployeeHasUser(true);
             // For now, we rely only on the Users collection check
             setSelectedEmployeeHasUser(false);
          }
        } catch (error) {
          console.error('Error checking for existing user:', error);
          toast.error(tRef.current('employees.toast.userCheckError'));
          setSelectedEmployeeHasUser(false); // Assume no user on error
        } finally {
          setIsCheckingUser(false);
        }
      } else {
        setSelectedEmployeeHasUser(false); // No employee selected or no email
        setIsCheckingUser(false);
      }
    };

    checkUserExists();
  }, [selectedEmployee]); // Re-run when selectedEmployee changes

  return { selectedEmployeeHasUser, isCheckingUser };
};

export default useEmployeeAccountStatus;
